function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKilnLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "25 0 385 120",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, "KILN \u2014 Video Management System") : title ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("desc", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "KILN logo: navy badge with K letterform, amber accent on lower arm and record indicator, wordmark with subtitle"), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 16,
    width: 82,
    height: 82,
    rx: 16,
    fill: "#1C2540",
    style: {
      fill: "rgb(28, 37, 64)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63,
    y1: 33,
    x2: 63,
    y2: 81,
    stroke: "#FFFFFF",
    strokeWidth: 9,
    strokeLinecap: "round",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 57,
    x2: 91,
    y2: 33,
    stroke: "#FFFFFF",
    strokeWidth: 8,
    strokeLinecap: "round",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 57,
    x2: 91,
    y2: 81,
    stroke: "#F09327",
    strokeWidth: 8,
    strokeLinecap: "round",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(240, 147, 39)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 29,
    r: 6,
    fill: "none",
    stroke: "#F09327",
    strokeWidth: 2,
    style: {
      fill: "none",
      stroke: "rgb(240, 147, 39)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 29,
    r: 2.5,
    fill: "#F09327",
    style: {
      fill: "rgb(240, 147, 39)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 142,
    y: 76,
    fontFamily: "var(--font-sans)",
    fontSize: 52,
    fontWeight: 700,
    letterSpacing: 5,
    fill: "var(--color-text-primary)",
    style: {
      fill: "rgb(20, 20, 19)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 52,
      fontWeight: 700,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "KILN"), /*#__PURE__*/React.createElement("text", {
    x: 145,
    y: 98,
    fontFamily: "var(--font-sans)",
    fontSize: 10.5,
    fontWeight: 400,
    letterSpacing: 3.8,
    fill: "var(--color-text-secondary)",
    style: {
      fill: "rgb(61, 61, 58)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: "10.5px",
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "VIDEO MANAGEMENT SYSTEM"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKilnLogo);
export default __webpack_public_path__ + "static/media/kiln_logo.8f0c9519.svg";
export { ForwardRef as ReactComponent };